import React, { Component } from "react";
import { connect } from "react-redux";
import { FormattedMessage, FormattedHTMLMessage } from "react-intl";
import { config } from "../../constants/domainConfig";
import { isGamiclub } from "../../constants/isGamiclub";
import { sendData } from "../../analytics/sendData";
import { userInfo } from "os";
import { isOnlyBeemobi } from "../../constants/isOnlyBeemobi";
import { isAppspool } from "../../constants/isAppspool";
import { isTheGamingClubs } from "../../constants/isTheGamingClubs";
import { isGamezClan } from "../../constants/isGamezClan";
import { isOnlyMobbfun } from "../../constants/isOnlyMobbfun";
import {
  isGameflares,
  isgamiHub,
  isGamiway,
} from "../../constants/productCondition";
import { getDomainTheme } from "../../utils/domainTheme.js";

const spanishDomain = config.lang == "es" ? true : false;
class Footer extends Component {
  onUnsubClick = (unsubscribe_url, e) => {
    e.preventDefault();
    sendData("", "", "", "unsubscribe clicked");
    window.open(unsubscribe_url);
  };

  render() {
    let currentLang = this.props.currentLang;
    let subDomain = config.subDomain;
    let contactus_url, TC_url, unsubscribe_url, PP_url;
    let compatibility_terms, service_mgmt;
    if (subDomain == "es") {
      contactus_url =
        "http://n.game-lords.com/es/tnc-game-lords?offer=1&_next=contact.html";
      TC_url =
        "http://n.game-lords.com/es/tnc-game-lords?offer=1&_next=general_conditions.html";
      unsubscribe_url = `http://n.game-lords.com/unsubscribe/es?domain=es.game-lords.com&token=${this.props.access.uid}`;
      return (
        <footer
          style={isGamiclub ? { borderTop: "1px solid green" } : null}
          className={`app-footer`}
        >
          <div className="footer-menu">
            <div className="footer-link">
              {unsubscribe_url ? (
                <div>
                  <a
                    href=""
                    onClick={this.onUnsubClick.bind(this, unsubscribe_url)}
                    target="_blank"
                  >
                    <FormattedHTMLMessage
                      id="unsubscribe"
                      defaultMessage="Unsubscribe"
                    />
                  </a>
                </div>
              ) : null}
              {TC_url ? (
                <div>
                  <a href={TC_url} target="_blank">
                    <FormattedHTMLMessage
                      id="tnc"
                      defaultMessage="Terms & Condition"
                    />
                  </a>
                </div>
              ) : null}
              {PP_url ? (
                <div>
                  <a href={PP_url} target="_blank">
                    <FormattedHTMLMessage
                      id="privacyPolicy"
                      defaultMessage="Privacy Policy"
                    />
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </footer>
      );
    }

    if (subDomain == "pe") {
      TC_url =
        "https://c1.mouisys.com/content/es/T&C%20Gamelords/?country=pe&service=game-lords";
      return (
        <footer
          style={isGamiclub ? { borderTop: "1px solid green" } : null}
          className={`app-footer`}
        >
          <div className="footer-menu">
            <div className="footer-link">
              {TC_url ? (
                <div>
                  <a href={TC_url} target="_blank">
                    <FormattedHTMLMessage
                      id="tnc"
                      defaultMessage="Terms & Condition"
                    />
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </footer>
      );
    }

    if (subDomain == "it") {
      TC_url = `http://n.game-lords.com/it/tnc-gamelords?offer=1&brand_name=gamelords&_next=index.html&token=${this.props.access.uid}`;
      PP_url = `http://n.game-lords.com/it/tnc-gamelords?offer=1&brand_name=gamelords&_next=privacy_policy.html&token=${this.props.access.uid}`;
      compatibility_terms = `http://n.game-lords.com/it/tnc-gamelords?offer=1&brand_name=gamelords&_next=compatibility.html&token=${this.props.access.uid}`;
      contactus_url = `http://n.game-lords.com/it/tnc-gamelords?offer=1&brand_name=gamelords&_next=cancellation.html&token=${this.props.access.uid}`;
      service_mgmt = `http://n.game-lords.com/it/tnc-gamelords?offer=1&brand_name=gamelords&_next=cancellation.html&token=${this.props.access.uid}`;
      return (
        <footer
          style={isGamiclub ? { borderTop: "1px solid green" } : null}
          className={`app-footer`}
        >
          <div className="footer-menu">
            <div className="footer-link">
              {TC_url && (
                <div>
                  <a href={TC_url} target="_blank">
                    <FormattedHTMLMessage
                      id="tnc"
                      defaultMessage="Terms and Conditions"
                    />
                  </a>
                </div>
              )}
              {PP_url && (
                <div>
                  <a href={PP_url} target="_blank">
                    <FormattedHTMLMessage
                      id="infoPrivacy"
                      defaultMessage="Info Privacy"
                    />
                  </a>
                </div>
              )}
              {compatibility_terms && (
                <div>
                  <a href={compatibility_terms} target="_blank">
                    <FormattedHTMLMessage
                      id="compatibilityTerms"
                      defaultMessage="Compatibility Terms"
                    />
                  </a>
                </div>
              )}
              {contactus_url && (
                <div>
                  <a href={contactus_url} target="_blank">
                    <FormattedHTMLMessage
                      id="contact_us"
                      defaultMessage="Contattaci"
                    />
                  </a>
                </div>
              )}
              {service_mgmt && (
                <div>
                  <a href={service_mgmt} target="_blank">
                    <FormattedHTMLMessage
                      id="serviceMgmt"
                      defaultMessage="Gestione servizio"
                    />
                  </a>
                </div>
              )}
            </div>
          </div>
        </footer>
      );
    }
    if (subDomain == "gr" && isGamiclub) {
      TC_url = `http://n.gamiclub.com/gr/tnc-gamiclub?device=pc&offer=1`;
      unsubscribe_url = `http://n.game-lords.com/unsubscribe/gr?lang=el&token=${this.props.access.uid}`;
      return (
        <footer
          style={isGamiclub ? { borderTop: "1px solid green" } : null}
          className={`app-footer`}
        >
          <div className="footer-menu">
            <div className="footer-link">
              {unsubscribe_url ? (
                <div>
                  <a
                    href=""
                    onClick={this.onUnsubClick.bind(this, unsubscribe_url)}
                    target="_blank"
                  >
                    <FormattedHTMLMessage
                      id="unsubscribe"
                      defaultMessage="Unsubscribe"
                    />
                  </a>
                </div>
              ) : null}
              {TC_url ? (
                <div>
                  <a href={TC_url} target="_blank">
                    <FormattedHTMLMessage
                      id="tnc"
                      defaultMessage="Terms & Condition"
                    />
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </footer>
      );
    }

    if (subDomain == "ro") {
      TC_url = `http://n.gamiclub.com/ro/tnc-gamiclub?offer=1`;
      unsubscribe_url = `http://n.gamiclub.com/unsubscribe/ro/?domain=ro.gamiclub.com&token=${this.props.access.uid}`;
      return (
        <footer
          style={isGamiclub ? { borderTop: "1px solid green" } : null}
          className={`app-footer`}
        >
          <div className="footer-menu">
            <div className="footer-link">
              {unsubscribe_url ? (
                <div>
                  <a
                    href=""
                    onClick={this.onUnsubClick.bind(this, unsubscribe_url)}
                    target="_blank"
                  >
                    <FormattedHTMLMessage
                      id="unsubscribe"
                      defaultMessage="Unsubscribe"
                    />
                  </a>
                </div>
              ) : null}
              {TC_url ? (
                <div>
                  <a href={TC_url} target="_blank">
                    <FormattedHTMLMessage
                      id="tnc"
                      defaultMessage="Terms & Condition"
                    />
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </footer>
      );
    }

    if (subDomain === "no" && !isGamiclub) {
      return (
        <footer
          style={isGamiclub ? { borderTop: "1px solid green" } : null}
          className={`app-footer no_app-footer`}
        >
          <div className="copyright-block">
            <div>
              <a href="mailto:no@content-clubs.com">
                Kontakt: no@content-clubs.com
              </a>
            </div>
            <div>
              <a href={`#/?uid=${this.props.account.user.uid}`}>
                {isGamiclub ? (
                  <FormattedHTMLMessage
                    id="footer.copyright.gamiclub"
                    defaultMessage="&copy; 2020 Gamiclub. All Rights Reserved"
                  />
                ) : window.location.hostname.includes("gameverse-lt") ? (
                  <FormattedHTMLMessage
                    id="footer.copyright.gameverse-lt"
                    defaultMessage="&copy; 2026 Gameverse. All Rights Reserved"
                  />
                ) : (
                  <FormattedHTMLMessage
                    id="footer.copyright"
                    defaultMessage="&copy; 2020 Gamelords. All Rights Reserved"
                  />
                )}
              </a>
            </div>
          </div>
        </footer>
      );
    }

    if (isOnlyBeemobi && subDomain === "es2") {
      const msisdn = this.props.access.subscriptionData
        ? this.props.access.subscriptionData["msisdn_full"]
        : "";
      if (!msisdn) return null;
      return (
        <footer
          style={{ borderTop: "1px solid green", padding: "5px 0px" }}
          className={`app-footer`}
        >
          <div className="copyright-block">
            <div>
              <a
                href={`https://checksubscription.com/?c=es&utm_source=es2.beemobi.me&msisdn=${msisdn}`}
              >
                Checksubscription
              </a>
            </div>
            <div>
              <a
                href={`http://n.beemobi.me/unsubscribe/es/?country=es&domain=es2.beemobi.me&token=${this.props.access.uid}`}
              >
                Darse de baja
              </a>
            </div>
          </div>
        </footer>
      );
    }

    if (subDomain === "se") {
      return (
        <footer
          style={isGamiclub ? { borderTop: "1px solid green" } : null}
          className={`app-footer se_app-footer`}
        >
          <div className="footer-menu">
            <div className="footer-link">
              <div>
                <a href="javascript:void(0)">
                  Några frågor? Låt prata 020 0753411 eller &nbsp;
                </a>
                <a href="mailto:info-se@mobileinfo.biz">
                  info-se@mobileinfo.biz
                </a>
              </div>
            </div>
          </div>
        </footer>
      );
    }
    if (subDomain == "eg" && isGamiclub) {
      const msisdn = this.props.access.subscriptionData
        ? this.props.access.subscriptionData["msisdn_full"]
        : "";
      if (!msisdn) return null;
      TC_url = `http://n.gamiclub.com/eg/eg-mm-gamiclub?offer=1&msisdn=${msisdn}`;
      return (
        <footer
          style={isGamiclub ? { borderTop: "1px solid green" } : null}
          className={`app-footer`}
        >
          <div className="footer-menu">
            <div className="footer-link">
              {TC_url ? (
                <div>
                  <a href={TC_url} target="_blank">
                    <FormattedHTMLMessage
                      id="tnc"
                      defaultMessage="Terms & Condition"
                    />
                  </a>
                </div>
              ) : null}
            </div>
          </div>
          <div className="copyright-block">
            <span>
              <a href={`#/?uid=${this.props.account.user.uid}`}>
                {window.location.hostname.includes("gameverse-lt") ? (
                  <FormattedHTMLMessage
                    id="footer.copyright.gameverse-lt"
                    defaultMessage="&copy; 2026 Gameverse. All Rights Reserved"
                  />
                ) : (
                  <FormattedHTMLMessage
                    id="footer.copyright.gamiclub"
                    defaultMessage="&copy; 2020 Gamiclub. All Rights Reserved"
                  />
                )}
              </a>
            </span>
          </div>
        </footer>
      );
    }
    if (subDomain == "za" && !isGamiclub) {
      TC_url = `http://n.lordgames.info/za/tnc-gamelords?device=pc&offer=1`;
      return (
        <footer
          style={isGamiclub ? { borderTop: "1px solid green" } : null}
          className={`app-footer`}
        >
          <div className="footer-menu">
            <div className="footer-link">
              {TC_url ? (
                <div>
                  <a href={TC_url} target="_blank">
                    <FormattedHTMLMessage
                      id="tnc"
                      defaultMessage="Terms & Condition"
                    />
                  </a>
                </div>
              ) : null}
            </div>
          </div>
          <div className="copyright-block">
            <span>
              <a href={`#/?uid=${this.props.account.user.uid}`}>
                <FormattedHTMLMessage
                  id="footer.copyright"
                  defaultMessage="&copy; 2020 Gamelords. All Rights Reserved"
                />
              </a>
            </span>
          </div>
        </footer>
      );
    }
    const theme = getDomainTheme();
    return (
      <footer
        style={
          isGamiclub
            ? { borderTop: "1px solid green" }
            : isGameflares
              ? { borderTop: "1px solid #FF394B" }
              : isGamiway
                ? { borderTop: "1px solid #b347a0" }
                : null
        }
        className={`app-footer ${isGameflares ? "app-footer-gameflares" : ""}`}
      >
        <div className="copyright-block">
          <span>
            <a href={`#/?uid=${this.props.account.user.uid}`}>
              {isGamiclub ? (
                isOnlyBeemobi ? (
                  <FormattedHTMLMessage
                    id="footer.copyright.beemobi"
                    defaultMessage="&copy; 2020 Beemobi. All Rights Reserved"
                  />
                ) : isOnlyMobbfun ? (
                  <FormattedHTMLMessage
                    id="footer.copyright.mobbfun"
                    defaultMessage="&copy; 2022 Mobbfun. All Rights Reserved"
                  />
                ) : window.location.hostname.includes("gameverse-lt") ? (
                  <FormattedHTMLMessage
                    id="footer.copyright.gameverse-lt"
                    defaultMessage="&copy; 2026 Gameverse. All Rights Reserved"
                  />
                ) : (
                  <FormattedHTMLMessage
                    id="footer.copyright.gamiclub"
                    defaultMessage="&copy; 2020 Gamiclub. All Rights Reserved"
                  />
                )
              ) : isAppspool ? (
                <FormattedHTMLMessage
                  id="footer.copyright.appspool"
                  defaultMessage="&copy; 2020 Appspool. All Rights Reserved"
                />
              ) : isGamezClan ? (
                <FormattedHTMLMessage
                  id="footer.copyright.gamezclan"
                  defaultMessage="&copy; 2020 Gamezclan. All Rights Reserved"
                />
              ) : isGameflares ? (
                <FormattedHTMLMessage
                  id="footer.copyright.gameflares"
                  defaultMessage="&copy; 2024 Gameflares. All Rights Reserved"
                />
              ) : isGamiway ? (
                <FormattedHTMLMessage
                  id="footer.copyright.gamiway"
                  defaultMessage="&copy; 2020 Gamiway. All Rights Reserved"
                />
              ) : isTheGamingClubs ? (
                <FormattedHTMLMessage
                  id="footer.copyright.gamiway"
                  defaultMessage="&copy; 2024 GamingClubs. All Rights Reserved"
                />
              ) : (
                <FormattedHTMLMessage
                  id={`footer.copyright.${theme.productName}`}
                  defaultMessage={`&copy; 2020 ${theme.productName}. All Rights Reserved`}
                />
              )}
            </a>
          </span>
        </div>
      </footer>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    account: state.AccountReducer,
    access: state.WelcomeReducer,
  };
};

export default connect(mapStateToProps)(Footer);



// WEBPACK FOOTER //
// ./src/components/Footer/Footer.js